import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/** Fixed id of the single status document — a deployment watches exactly one mailbox. */
export const MAIL_SYNC_STATUS_ID = 'mail-sync-status';

/**
 * What the mailbox poll last did, persisted so it is readable through the app itself.
 * Without it the only record is the container log, which nobody reads until mails are missed.
 */
@Entity()
export class MailSyncStatus extends MongoEntity {
  static override _class = 'MailSyncStatus';
  static override _collectionName = 'mail-sync-status';

  /** Start of the most recent run. Stays put while a run hangs — that gap is what makes a wedge visible. */
  @Field(() => Date) runStartedAt: Maybe<Date>;

  @Field(() => Date) lastSuccessAt: Maybe<Date>;

  /** Message of the last failed run, cleared by the next successful one. */
  @Field(() => String) lastError: Maybe<string>;

  /** Start time of a run that blew the time limit: still pending, not failed — the queue is stuck. */
  @Field(() => Date) stalledSince: Maybe<Date>;

  constructor(doc: PartialEntityData<MailSyncStatus>) {
    super(doc);
  }
}
